import contract from './contract.schema.json';

export type SchemaNames = 'contract';

export const schemas: Record<SchemaNames, any> = {
  contract
};
